import 'script-loader!jquery/dist/jquery.min';
import 'script-loader!what-input/dist/what-input.min';
import 'script-loader!foundation-sites/dist/js/foundation.min';
import 'script-loader!magnific-popup/dist/jquery.magnific-popup.min';
import AOS from 'aos';
import 'aos/dist/aos.css';

import { library } from '@fortawesome/fontawesome-svg-core';
import {
  faPlay,
  faPause,
  faFileDownload
} from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';

import Vue from 'vue';
import App from './App.vue';
import router from './router';

import VueLogger from 'vuejs-logger';

import VueGtag from 'vue-gtag';

const options = {
  isEnabled: true,
  logLevel: process.env.NODE_ENV === 'production' ? 'error' : 'debug',
  stringifyArguments: false,
  showLogLevel: true,
  showMethodName: true,
  separator: '|',
  showConsoleColors: true
};

Vue.use(VueLogger, options);

Vue.use(VueGtag, {
  config: { id: process.env.VUE_APP_GOOGLE_ANALYTICS_ID }
}, router);

library.add(
  faPlay,
  faFileDownload,
  faPause
);
Vue.component('FontAwesomeIcon', FontAwesomeIcon);

Vue.config.productionTip = false;

Vue.prototype.$quotes = [
  {
    name: 'Katrina M. Hood, MD',
    formattedName: 'Katrina M. Hood, MD',
    position: [
      'Vice Chair, SVMIC Board of Directors',
      'Pediatrics',
    ],
    quote: 'We remain dedicated to making healthcare safer and better—striving to achieve all the goals we, as doctors, aim to accomplish.',
    photos: {
      quote: require('./assets/quote-katrina-hood.png'),
      bio: require('./assets/bio-katrina-hood.png'),
    },
    bio: 'In 2006, Dr. Hood joined the SVMIC Risk Management Committee, and she has since shared that accepting a position on the board was an easy decision, given her alignment with SVMIC\'s mission and values. Outside of her professional commitments, Dr. Hood enjoys spending time with her family, taking care of her dogs, gardening, running, and indoor rowing. Medicine runs in her family—her husband is a physician, and two of their three children are following in their footsteps to become doctors.',
    bioUrl: 'https://www.svmic.com/board-of-directors/katrina-hood',
  },
  {
    name: 'Matthew L. Perkins, MD',
    formattedName: 'Matthew L. Perkins, MD',
    position: [
      'Chair, SVMIC Board of Directors',
      'Internal Medicine and Pediatrics',
    ],
    quote: 'A true leader is willing to act for the greater good, not for personal recognition.',
    photos: {
      quote: require('./assets/quote-matthew-perkins.png'),
      bio: require('./assets/bio-matthew-perkins.png'),
    },
    bio: 'Dr. Perkins has always been dedicated to serving others, and when the opportunity to join the SVMIC board arose, he saw it as a great chance to deepen his understanding of a critical aspect of healthcare. With experience building his own group practice, serving on a local Independent Physician Association (IPA) board, and holding various hospital leadership roles, Dr. Perkins now brings valuable and unique insights to SVMIC in his role as Chair of the board.',
    bioUrl: 'https://www.svmic.com/board-of-directors/matthew-perkins',
  },
  {
    name: 'Craig A. Myers, MD',
    formattedName: 'Craig <span class="have-heart-alt">A</span>. Myers, MD',
    position: [
      'Secretary, SVMIC Board of Directors',
      'Obstetrics/Gynecology',
    ],
    quote: 'The Board of Directors is excited by SVMIC\'s continued exploration of technology to further enhance patient safety and mitigate risk.',
    photos: {
      quote: require('./assets/quote-craig-myers.png'),
      bio: require('./assets/bio-craig-myers.png'),
    },
    bio: 'Dr. Myers was drawn to medicine for two main reasons: a desire to help those in need and a passion for science. Before joining the SVMIC board in 2021, he served on the SVMIC Underwriting Committee for 15 years. He deeply respects SVMIC’s outstanding organization and its strong commitment to supporting physicians. Outside of work, Dr. Myers enjoys time in the mountains, fly fishing, socializing with friends, renovating his house, and tending to his small farm.',
    bioUrl: 'https://www.svmic.com/board-of-directors/craig-myers',
  }
];

Vue.prototype.$bios = (
  Vue.prototype.$quotes.sort((a, b) => {
    if (a.name === b.name) return 0;
    if (a.name.includes('Matthew')) return -1;
    if (b.name.includes('Matthew')) return 1;
    if (a.name.includes('Craig')) return 1;
    if (b.name.includes('Craig')) return -1;
  })
);

export const vm = new Vue({
  created () {
    AOS.init({
      offset: 220,
      delay: 50,
      duration: 600,
      easing: 'easeOutQuart'
    });
  },
  router: router,
  render: h => h(App)
}).$mount('#app');
